<script>
import ArtistSearch from '@/components/artist/ArtistSearch.vue'

export default {
  name: 'ArtistCommissionComponentsCreateEdit',
  components: { ArtistSearch },
  computed: {
    canEditPaymentTime() {
      return this.dialogForm.settle_method === 'private' ||
        (this.dialogForm.settle_method === 'corporate' && Number(this.dialogForm.actual_pay) < 0)
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      dialogLoading: false,
      artistSelectorVisible: false,
      dialogArtistVisible: false,
      loadingSync: false,
      dialogTitle: '',
      dialogForm: {
        date_time: '',
        artist_id: '',
        nickname: '',
        commerce_pay: 0,//卖货分成
        publicity_pay: 0,//推广分成
        brokerage_pay: 0,//佣金分成
        other_pay: 0, // 其他应扣/补款
        marketing_costs: 0,//承担的营销费用
        due_total: 0,//应付款合计
        person_tax: 0,//个税
        actual_pay: 0,//实付款
        invoice_amount: 0,//发票总额
        deduct_remark: '',
        settle_method: 'corporate',
        need_invoice: '',
        letter_status: '',
        apply_time: null,
        payment_time: null,
        remark: '',
        invoice_type: null,
        tax_point: null
      },
      dialogFormRules: {
        date_time: [
          { required: true, message: '请选择月份', trigger: 'change' }
        ],
        nickname: [
          { required: true, message: '请选择红人', trigger: 'change' }
        ],
        settle_method: [
          { required: true, message: '请选择结算方式', trigger: 'change' }
        ]
        // artist_id: [
        //   { required: true, message: '请选择红人', trigger: 'change' }
        // ]
      },
      // 分成函状态
      letterStatusRange: ['双方已签', '红人未签', '未发起'],
    }
  },
  methods: {
    add() {
      this.dialogFormVisible = true
      this.artistSelectorVisible = true
      this.dialogTitle = '新增红人分成'
      this.dialogForm = {
        date_time: '',
        artist_id: '',
        nickname: '',
        commerce_pay: 0,//卖货分成
        publicity_pay: 0,//推广分成
        brokerage_pay: 0,//佣金分成
        other_pay: 0, // 其他应扣/补款
        marketing_costs: 0,//承担的营销费用
        due_total: 0,//应付款合计
        person_tax: 0,//个税
        actual_pay: 0,//实付款
        invoice_amount: 0,//发票总额
        deduct_remark: '',
        settle_method: 'corporate',
        need_invoice: '',
        apply_time: null,
        payment_time: null,
        remark: '',
        invoice_type: null,
        tax_point: null
      }
    },
    async edit(row) {
      // 加载详情
      // await this.$api.getArtistDivide(id)
      this.artistSelectorVisible = false
      this.dialogLoading = false
      this.dialogForm = { ...row }
      this.dialogFormVisible = true
      this.dialogTitle = `编辑红人(${row.nickname})分成`

    },
    moneyFormat(value) {
      return this.$utils.numberFormat(value, 2, '.', ',', 'round')
    },
    // eslint-disable-next-line no-unused-vars
    handleChangeMethod(val) {
      this.handleCalcTax()
    },
    handleCalcDueTotal() {
      /**
       *   commerce_pay: 0,//卖货分成
       *   publicity_pay: 0,//推广分成
       *   brokerage_pay: 0,//佣金分成
       *   other_pay: 0, // 其他应扣/补款
       *   marketing_costs: 0,//承担的营销费用
       * @type {number}
       */
      //应收款合计 = 卖货分成 + 推广分成 + 佣金分成 - 其他应扣/补款 - 承担的营销费用
      this.dialogForm.due_total = this.roundToTwo((this.dialogForm.commerce_pay / 1 + this.dialogForm.publicity_pay / 1 + this.dialogForm.brokerage_pay / 1 - this.dialogForm.other_pay / 1 - this.dialogForm.marketing_costs / 1))
      // this.$notify({
      //   type: 'info',
      //   title: '应收款合计',
      //   // message: `实付款（${this.dialogForm.actual_pay}） = 应付款合计（${this.dialogForm.due_total}） - 个税（${this.dialogForm.person_tax}）`,
      //   message: `应收款合计 = 卖货分成 (${this.dialogForm.commerce_pay}) + 推广分成 (${this.dialogForm.publicity_pay}) + 佣金分成 (${this.dialogForm.brokerage_pay}) + 其他应扣/补款 (${this.dialogForm.other_pay}) - 承担的营销费用 (${this.dialogForm.marketing_costs})`,
      //   offset: 300
      // })
      //向下计算
      // this.handleCalcTax()

    },
    /**
     * 个税计算公式：
     *
     * 1.结算方式为 对公 时，个税为0；
     *
     * 2.结算方式为 个人 时，个税公式：
     *        输入字段：应付款合计（income），类型为：float ；
     *        输出字段：个税（tax），类型为：float；
     *        计算 逻辑：
     *                        1.计算费用扣除额（deduction），如果 income < 4000，deduction = 800；否则 deduction = income * 0.2；
     *                        2.计算应纳税所得额（taxable_income）= income - deduction；
     *                        3.计算三档税额（并行计算）
     *                                  tier1 = taxable_income * 0.2 - 0
     *                                  tier2 = taxable_income * 0.3 - 2000
     *                                  tier3 = taxable_income * 0.4 - 7000
     *                         4.取最大值（不低于0）
     *                                   tax_raw = max(teir1，teir2，teir3，0)
     *                         5.保留两位小数
     *                                    tax = round(tax_raw，2)
     */
    handleCalcTax() {
      //计算个税
      if (this.dialogForm.settle_method === 'private') {
        // this.$notify.info('结算方式：个人')
        // 费用扣除额（deduction）
        let deduction = 800
        if (this.dialogForm.due_total >= 4000) {
          deduction = this.dialogForm.due_total * 0.2
        }
        //应纳税所得额（taxable_income）
        const taxable_income = this.dialogForm.due_total - deduction
        // this.$notify({
        //   type: 'info',
        //   title: '费用计算',
        //   message: `应付款合计：${this.dialogForm.due_total},费用扣除额：${deduction}，应纳税所得额：${taxable_income}`,
        //   offset: 100
        // })
        const tier1 = taxable_income * 0.2 - 0
        const tier2 = taxable_income * 0.3 - 2000
        const tier3 = taxable_income * 0.4 - 7000
        const taxVal = Math.max(tier1, tier2, tier3)
        // this.$notify({
        //   type: 'info',
        //   title: '三档税额',
        //   message: `第一档：${tier1} 第二档：${tier2} 第三档：${tier3}`,
        //   offset: 200
        // })

        // console.log(`${taxable_income},${deduction}`)
        // console.log(`${tier1},${tier2},${tier3}`)
        if (taxVal > 0) {
          //对于需要参与后续计算的场景，推荐使用基于放大和四舍五入的方法，并添加Number.EPSILON来修正浮点精度误差
          this.dialogForm.person_tax = this.roundToTwo(taxVal)
        } else {
          this.dialogForm.person_tax = 0
          this.$notify.warning(`计算所得个税(${taxVal})小于等于0，设置为0`)
        }
      } else {
        this.dialogForm.person_tax = 0
      }

      // 重新计算【实付款】
      // this.handleCalcActualPay()
    },
    // 保留2位小数
    roundToTwo(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100
    },
    handleCalcActualPay() {
      this.handleCalcDueTotal()
      this.handleCalcTax()
      // 实付款 = 应付款合计 - 个税
      this.dialogForm.actual_pay = this.dialogForm.due_total - this.dialogForm.person_tax
      // 结算方式：对公 且 发票类型：专票
      // if (this.dialogForm.settle_method === 'corporate' && this.dialogForm.invoice_type === 'special') {
      //   this.dialogForm.actual_pay = this.dialogForm.actual_pay * (1 + this.dialogForm.tax_point / 100)
      // }
      this.dialogForm.actual_pay = this.roundToTwo(this.dialogForm.actual_pay)
      // this.$notify({
      //   type: 'info',
      //   title: '计算实付款',
      //   message: `实付款（${this.dialogForm.actual_pay}） = 应付款合计（${this.dialogForm.due_total}） - 个税（${this.dialogForm.person_tax}）`,
      //   offset: 300
      // })

      /**
       * 3.发票总额，分三种情况
       *       3.1 结算方式为 个人 时，发票总额 = 应付款合计
       *       3.2 结算方式为 对公，发票类型为 普通发票时，发票总额 = 应付款合计
       *       3.3 结算方式为 对公，发票类型为 专用发票时，发票总额 = 应付款合计 *（1+税点）
       */
      this.dialogForm.invoice_amount = this.dialogForm.due_total || 0
      if (this.dialogForm.settle_method === 'corporate' && this.dialogForm.invoice_type === 'special') {
        this.dialogForm.invoice_amount = this.dialogForm.due_total * (1 + this.dialogForm.tax_point / 100)
      }
    },
    // 弹窗关闭时清空数据
    handleDialogClose() {
      this.dialogForm = {
        date_time: '',
        artist_id: '',
        nickname: '',
        commerce_pay: 0,
        publicity_pay: 0,
        brokerage_pay: 0,
        other_pay: 0,
        marketing_costs: 0,
        due_total: 0,
        person_tax: 0,
        actual_pay: 0,
        deduct_remark: '',
        settle_method: '',
        need_invoice: '',
        apply_time: '',
        payment_time: '',
        remark: ''
      }
      this.artistSelectorVisible = false
      // 清除表单验证状态
      if (this.$refs.dialogFormRef) {
        this.$refs.dialogFormRef.clearValidate()
      }
    },
    // 处理红人选择
    handleArtistSelect(item) {
      // console.log(item)
      if (item && item.artist_id) {
        this.dialogForm.artist_id = item.artist_id
        this.dialogForm.nickname = item.nickname
        this.artistSelectorVisible = false
        // 查询红人的最新结算信息
        this.getLastPayment()
      } else {
        this.dialogForm.artist_id = ''
        this.dialogForm.nickname = ''
      }
    },
    async getLastPayment() {
      //
      if (this.dialogForm.artist_id) {
        this.loadingSync = true
        const data = await this.$api.getLastPayment(this.dialogForm.artist_id)
        if (data) {
          this.dialogForm.settle_method = data.settle_method || ''
          this.dialogForm.invoice_type = data.invoice_type || ''
          this.dialogForm.tax_point = data.tax_point || ''
        } else {
          this.$notify.warning(`【红人：${this.dialogForm.nickname}】未设置结算信息（签约信息-详情-编辑：添加红人结算信息）！！！`)
        }

        setTimeout(() => {
          this.loadingSync = false
        }, 1000)


      }

    },
    showEditArtistSelector() {
      this.artistSelectorVisible = true
    },
    // 表单提交
    async handleSubmit() {
      this.$refs.dialogFormRef.validate(async (valid) => {
        if (valid) {
          this.dialogLoading = true
          try {
            setTimeout(() => {
              this.dialogLoading = false
            }, 1000)
            // 这里调用API提交数据
            localStorage.setItem('page:artist_commission:dialogForm', JSON.stringify(this.dialogForm))

            const data = await this.$api.addArtistDivide(this.dialogForm)
            if (data) {
              if (this.dialogForm.id) {
                this.msgSuccess('保存成功')
              } else {
                this.msgSuccess('新增成功')
                // this.$notify.success('新增成功')
              }
              this.dialogFormVisible = false
              // await this.getList() // 刷新列表
              this.$emit('saved', data)
            } else {
              this.$notify.error('新增失败')
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$notify.error('提交失败，请重试')
          } finally {
            this.dialogLoading = false
          }
        } else {
          this.dialogLoading = false
          this.$notify.warning('请填写必填项')
          return false
        }
      })
    }
  }

}

</script>

<template>
  <div>
    <el-dialog :title='dialogTitle' :visible.sync='dialogFormVisible' width='800px' @close='handleDialogClose'>

      <el-form :model='dialogForm'
               :rules='dialogFormRules'
               ref='dialogFormRef'
               label-width='130px'
               label-position='right'
               label-suffix='：'>
        <el-row :gutter='20'>
          <el-col :span='12'>
            <el-form-item label='月份' prop='date_time'>
              <el-date-picker
                v-model='dialogForm.date_time'
                type='month'
                value-format='yyyy-MM'
                format='yyyy年MM月'
                placeholder='选择月份'
                style='width: 100%'
              />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='红人昵称' prop='nickname'>

              <ArtistSearch @handleSelect='handleArtistSelect' v-if='artistSelectorVisible'></ArtistSearch>
              <div class='flex-sb' v-else>
                <div>
                  <span>{{ dialogForm.nickname || '--' }}</span>
                  <el-link type='primary' class='el-icon-edit-outline' @click='showEditArtistSelector'
                           style='margin-left: 10px;'></el-link>
                </div>
                <el-link v-loading='loadingSync' :disabled='loadingSync' v-if='dialogForm.artist_id'
                         title='同步红人结算信息(签约详情页面中录入)' type='primary' class='el-icon-refresh'
                         @click='getLastPayment' style='margin-left: 10px'>结算信息
                </el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter='20'>
          <el-col :span='12'>
            <el-form-item label='卖货分成'>
              <el-input-number
                v-model='dialogForm.commerce_pay'
                :precision='2'
                placeholder='电商应付款'
                style='width: 100%'
              />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='推广分成'>
              <el-input-number
                v-model='dialogForm.publicity_pay'
                :precision='2'
                placeholder='推广应付款'
                style='width: 100%'
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter='20'>
          <el-col :span='12'>
            <el-form-item label='佣金分成'>
              <el-input-number
                v-model='dialogForm.brokerage_pay'
                :precision='2'
                placeholder='佣金应付款'
                style='width: 100%'
              />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='其他应扣/补款'>
              <el-input-number
                v-model='dialogForm.other_pay'
                :precision='2'
                placeholder='补款：正数；扣款：负数'
                style='width: 100%'
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter='20'>
          <el-col :span='12'>
            <el-form-item label='承担的营销费用'>
              <el-input-number
                v-model='dialogForm.marketing_costs'
                :precision='2'
                style='width: 100%'
              />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='应付款合计'>
              <template slot='label'>
                <el-tooltip content='应收款合计 = 卖货分成 + 推广分成 + 佣金分成 - 其他应扣/补款 - 承担的营销费用'
                            placement='top'>
                  <el-button type='text'><span class='el-icon-info'></span></el-button>
                </el-tooltip>
                <span>应付款合计：</span>
              </template>
              <div class='flex-sb'>
                <span>{{ moneyFormat(dialogForm.due_total) }}</span>
                <!--                <el-button icon='el-icon-refresh' type='text' @click.native.stop='handleCalcDueTotal'>计算</el-button>-->
              </div>

              <!--                    <el-input-->
              <!--                      v-model='dialogForm.due_total'-->
              <!--                      style='width: 100%'-->
              <!--                      readonly-->
              <!--                    >-->
              <!--                      <el-button slot='append' @click.native.stop='handleCalcDueTotal'>计算</el-button>-->
              <!--                    </el-input>-->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter='20'>
          <el-col :span='12'>
            <el-form-item label='结算方式' prop='settle_method'>
              <el-select v-model='dialogForm.settle_method' placeholder='请选择结算方式'
                         @change='handleChangeMethod' style='width: 100%' clearable>
                <el-option label='对公' value='corporate' />
                <el-option label='个人' value='private' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12' v-if='dialogForm.settle_method==="corporate"'>
            <el-form-item label='发票类型' prop='invoice_type'>
              <el-select v-model='dialogForm.invoice_type' placeholder='请选择发票类型' clearable
                         style='width: 100%'>
                <el-option label='普通发票' value='normal' />
                <el-option label='专用发票' value='special' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12' v-if='dialogForm.settle_method==="corporate"'>
            <el-form-item label='票面税点' prop='tax_point'>
              <el-select v-model='dialogForm.tax_point' filterable allow-create placeholder='请选择票面税点' clearable
                         style='width: 100%'>
                <el-option label='未设置' value='0' />
                <el-option label='1%' value='1.00' />
                <el-option label='3%' value='3.00' />
                <el-option label='6%' value='6.00' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12' v-if='dialogForm.settle_method==="private"'>
            <el-form-item label='个税'>
              <template slot='label'>
                <el-tooltip content='个税计算公式：

1.结算方式为 对公 时，个税为0；

2.结算方式为 个人 时，个税公式：
       输入字段：应付款合计（income），类型为：float ；
       输出字段：个税（tax），类型为：float；
       计算 逻辑：
                       1.计算费用扣除额（deduction），如果 income < 4000，deduction = 800；否则 deduction = income * 0.2；
                       2.计算应纳税所得额（taxable_income）= income - deduction；
                       3.计算三档税额（并行计算）
                                 tier1 = taxable_income * 0.2 - 0
                                 tier2 = taxable_income * 0.3 - 2000
                                 tier3 = taxable_income * 0.4 - 7000
                        4.取最大值（不低于0）
                                  tax_raw = max(teir1，teir2，teir3，0)
                        5.保留两位小数
                                   tax = round(tax_raw，2)' placement='top'>
                  <div slot='content'>
                    <span style='font-weight: bolder;font-size: 16px;'>个税计算公式：</span><br />
                    <div style='margin-left: 10px;padding: 5px'>
                      1.结算方式为 对公 时，个税为0；
                    </div>
                    <div style='margin-left: 10px;padding: 5px'>
                      2.结算方式为 个人 时，个税公式：<br />
                      <div style='margin-left: 10px;padding: 5px'> 输入字段：应付款合计（income），类型为：float ；</div>
                      <div style='margin-left: 10px;padding: 5px'> 输出字段：个税（tax），类型为：float；</div>
                      <div style='margin-left: 10px;padding: 5px'>
                        计算 逻辑：
                        <ul>
                          <li>1.计算费用扣除额（deduction），如果 income &lt; 4000，deduction &equals; 800；否则
                            deduction &equals income * 0.2；
                          </li>
                          <li>2.计算应纳税所得额（taxable_income）= income - deduction；</li>
                          <li>3.计算三档税额（并行计算）
                            <ol>
                              <li> tier1 = taxable_income * 0.2 - 0</li>
                              <li> tier2 = taxable_income * 0.3 - 2000</li>
                              <li> tier3 = taxable_income * 0.4 - 7000</li>
                            </ol>
                          </li>
                          <li>4.取最大值（不低于0）</li>
                          <li>5.保留两位小数</li>
                        </ul>
                      </div>
                    </div>

                  </div>
                  <el-button type='text'><span class='el-icon-info'></span></el-button>
                </el-tooltip>
                <span>个税：</span>
              </template>
              <div class='flex-sb'>
                <span>{{ moneyFormat(dialogForm.person_tax) }}</span>
                <!--                <el-button icon='el-icon-refresh' type='text' @click.native.stop='handleCalcTax'>计算</el-button>-->
              </div>
              <!--                    <el-input-->
              <!--                      v-model='dialogForm.person_tax'-->
              <!--                      readonly-->
              <!--                      style='width: 100%'-->
              <!--                    >-->
              <!--                      <el-button slot='append' @click.native.stop='handleCalcTax'>计算</el-button>-->
              <!--                    </el-input>-->
            </el-form-item>

          </el-col>
          <el-col :span='12'>
            <el-form-item label='实付款'>
              <template slot='label'>
                <el-tooltip content='实付款 = 应付款合计 - 个税' placement='top'>
                  <el-button type='text'><span class='el-icon-info'></span></el-button>
                </el-tooltip>
                <span>实付款：</span>
              </template>
              <div class='flex-sb'>
                <span>{{ moneyFormat(dialogForm.actual_pay) }}</span>
                <el-button icon='el-icon-refresh' type='text' @click.native.stop='handleCalcActualPay'>计算</el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='是否开票'>
              <el-select v-model='dialogForm.need_invoice' placeholder='是否开票' style='width: 100%'>
                <el-option label='是' value='Y' />
                <el-option label='否' value='N' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='发票总额'>
              <template slot='label'>
                <span>发票总额：</span>
              </template>
              <div class='flex-sb'>
                <span v-if='dialogForm.invoice_amount'>{{ moneyFormat(dialogForm.invoice_amount) }}</span>
                <span v-else> - </span>
                <!--                <el-button icon='el-icon-refresh' type='text' @click.native.stop='handleCalcActualPay'>计算</el-button>-->
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter='20'>
          <el-col :span='12'>
            <el-form-item label='发放时间'>
              <span v-if='!canEditPaymentTime'> {{ dialogForm.payment_time || '-' }}</span>
              <el-date-picker
                v-else
                v-model='dialogForm.payment_time'
                type='datetime'
                placeholder='选择发放时间'
                default-time='12:00:00'
                style='width: 100%'
                value-format='yyyy-MM-dd HH:mm:ss'
              />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='分成函状态'>
              <el-select v-model='dialogForm.letter_status' placeholder='分成函状态' style='width: 100%'
                         clearable>
                <el-option v-for='(option) in letterStatusRange' :value='option' :label='option'
                           :key='option'></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label='扣（补款）备注'>
          <el-input
            v-model='dialogForm.deduct_remark'
            type='textarea'
            :rows='3'
            placeholder='请输入扣（补款）备注'
            maxlength='100'
            show-word-limit
          />
        </el-form-item>

        <el-form-item label='备注'>
          <el-input
            v-model='dialogForm.remark'
            type='textarea'
            :rows='3'
            placeholder='请输入备注信息'
            maxlength='100'
            show-word-limit
          />
        </el-form-item>
      </el-form>

      <div slot='footer' class='dialog-footer'>
        <el-button @click='dialogFormVisible = false'>取 消</el-button>
        <el-button type='primary' @click='handleSubmit' :loading='dialogLoading' :disabled='dialogLoading'>确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>

</style>
